import { createActionGroup } from '@ngrx/store';

export const CampagnePatrimoineActions = createActionGroup({
  source: 'Campagne Patrimoine',
  events: {}
});
